import {Component, EventEmitter, Inject, Output} from "@angular/core";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {NewsService} from "@app/services/news/news.service";

@Component({
    selector:'flex-news-sort',
    templateUrl: './news-sort.component.html',
    styleUrls:['./news-sort.component.css']
})
export class NewsSortComponent{
    constructor(public newsService: NewsService) {
    }

    drop(event: CdkDragDrop<any>) {
        this.newsService.sort(event);
    }

}
